import styled from '@emotion/styled'

import media from '../../../common/MediaQueries'

const BrandAssetsListingStyled = styled.ul`
  display: flex;
  flex-direction: column;

  @media ${media.phone} {
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 -1rem;
  }
`

const BrandAssetsListingItemStyled = styled.li`
  @media ${media.maxPhone} {
    &:not(:last-of-type) {
      margin-bottom: 5rem;
    }
  }
  @media ${media.phone} {
    flex-basis: 50%;
    max-width: 50%;
    padding: 0 1rem 5rem;
  }
`

export { BrandAssetsListingStyled, BrandAssetsListingItemStyled }
